var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{staticClass:"share-thumb",attrs:{"src":_vm.image,"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }